import { Breadcrumb, Button, Card, Col, Input, message, Row, Table } from 'antd';
import gql from 'graphql-tag';
import React, { Component } from 'react';
import { Mutation, Query } from 'react-apollo';
import { Link, RouteComponentProps } from 'react-router-dom';

import { Panel } from '../../components/Panel';
import { client } from '../../services/api';
import { USER_PROLES_QUERY, USER_ROLE_PERMISSIONS_QUERY } from './constant';
import { UserPermission, UserRole } from './type';

interface State {
  id: number;
  name?: string;
  userPermissionIds?: string[];
}

interface Props {
  id: string;
}

type AllProps = RouteComponentProps<Props>;

const updateUserRoleMutation = gql`
  mutation updateUserRole($id: ID, $name: String, $permissionIds: [ID]!) {
    updateUserRole(id: $id, name: $name, permissionIds: $permissionIds) {
      id
      name
      permissions {
        id
        description
        action
        resource
      }
    }
  }
`;

export class EditRole extends Component<AllProps, State> {
  constructor(props: AllProps) {
    super(props);
    this.state = {
      id: Number(props.match.params.id),
      name: '',
      userPermissionIds: [],
    };
  }

  async componentDidMount() {
    try {
      const response = await client.query<{ userRoles: UserRole[] }>({
        query: USER_PROLES_QUERY,
        variables: { id: Number(this.props.match.params.id) },
      });
      const { userRoles = [] } = response.data || {};
      if (userRoles && userRoles.length > 0) {
        const userRole = userRoles[0];
        const userPermissionIds = userRole.permissions.map(permission => {
          return String(permission.id);
        });
        this.setState({
          userPermissionIds,
          name: userRole.name,
        });
      }
    } catch (error) {
      message.error(`${error.message}`);
    }
  }

  onUserRoleNameInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({
      name: e.target.value,
    });
  };

  onSelectChange = (selectedUserPermissionIds: string[]) => {
    this.setState({ userPermissionIds: selectedUserPermissionIds });
  };

  render() {
    const { id, name, userPermissionIds } = this.state;
    const permissionIds = userPermissionIds ? userPermissionIds.map(value => Number(value)) : [];
    return (
      <div>
        <Breadcrumb style={{ marginBottom: 10, fontSize: 13 }}>
          <Breadcrumb.Item>
            <Link to={`/Home`}>首页</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to={`/role-permission-role/role/list`}>角色列表</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>编辑角色</Breadcrumb.Item>
        </Breadcrumb>
        <Panel style={{ marginTop: 10 }}>
          <Card>
            <Row type={'flex'} align={'middle'} gutter={24}>
              <Col span={21}>
                <span>角色名称：</span>
                <Input style={{ width: 300 }} value={name} onChange={this.onUserRoleNameInput} />
              </Col>
              <Col span={3}>
                <Mutation
                  mutation={updateUserRoleMutation}
                  variables={{ id, name, permissionIds }}
                  refetchQueries={[{ query: USER_PROLES_QUERY }]}
                >
                  {(updateUserRole, { loading }) => {
                    return (
                      <>
                        <Button
                          type="primary"
                          loading={loading}
                          onClick={async () => {
                            try {
                              if (name && userPermissionIds && userPermissionIds.length) {
                                await updateUserRole();
                                this.props.history.goBack();
                                message.success('更新成功');
                                return;
                              }
                              message.error('请将信息填写完整！');
                            } catch (error) {
                              message.error(`${error.message}`);
                            }
                          }}
                        >
                          更新
                        </Button>
                      </>
                    );
                  }}
                </Mutation>
              </Col>
            </Row>
          </Card>
          <Query query={USER_ROLE_PERMISSIONS_QUERY}>
            {({ loading, error, data }) => {
              if (error) return <div>{error.message}</div>;
              const allUserPermissions = (data && data.userRolePermissions) || [];
              return (
                <Table<UserPermission>
                  loading={loading}
                  dataSource={allUserPermissions}
                  rowSelection={{ selectedRowKeys: userPermissionIds, onChange: this.onSelectChange }}
                  rowKey={row => `${row.id}`}
                  pagination={false}
                >
                  <Table.Column dataIndex="id" title="权限ID" key="id" />
                  <Table.Column dataIndex="description" title="描述" key="description" />
                  <Table.Column dataIndex="action" title="行为" key="name" />
                  <Table.Column dataIndex="resource" title="来源组件" key="resource" />
                </Table>
              );
            }}
          </Query>
        </Panel>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/rolePermission/EditRole.tsx